import { v4 as uuidv4 } from 'uuid'
import { onMounted, onUnmounted } from 'vue'
const watchMessageQueueMap: Record<string, (data: string) => void> = {}

export function initWatchMessage(): void {
  window.watchMessage = (data: string) => {
    Object.keys(watchMessageQueueMap).forEach((key) => watchMessageQueueMap[key](data))
  }
}

export function useWatchMessageHandle(fn: (data: string) => void): void {
  const key = uuidv4()
  onMounted(() => {
    watchMessageQueueMap[key] = fn
  })
  onUnmounted(() => {
    delete watchMessageQueueMap[key]
  })
}
